import { Backdrop, Link, useMediaQuery } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '../../base/arranger';
import Button from '../../base/button';
import Modal from '../../base/modal';

import { DesignToken } from '~/client/components/base/core';
import * as GQL from '~/graphql/generated/client';
import Spacer, { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface ModalContentProps {
  className?: string;
  onRemoveHandler: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  policy: GQL.PolicyFragment;
}

const PublicPolicyModalImpl: React.FC<ModalContentProps> = ({
  className,
  open,
  setOpen,
  policy,
}) => {
  const isDarkMode = false;

  return (
    <Modal
      slots={{ backdrop: Backdrop }}
      className={className}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(186, 187, 191, 0.4)',
          },
        },
      }}
      sx={{
        '.MuiPaper-root': {
          background: `${isDarkMode ? DesignToken.textPrimary : DesignToken.surface2}`,
          minWidth: '350px',
          paddingBottom: '10px',
        },
      }}
      open={open}
      onClose={() => setOpen(false)}
    >
      <Arranger
        direction="column"
        justify="flex-start"
        style={{
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <div>
          <Text sz="h1">{policy.name}</Text>
          <Spacer mb={spc.xxs} />
          <Text sz="bold-body12" className={className}>
            {policy?.identifier} · {policy?.version}
          </Text>
          <Spacer mb={spc.s} />
          <Text sz="title" color="secondary">
            DESCRIPTION
          </Text>
          <Spacer mb={spc.xxs} />
          <Text sz="body16" className={className}>
            {policy?.description}
          </Text>
          <Spacer mb={spc.l} />
          {/* <Text sz="title" color="secondary">
            CONTROL BUNDLES
          </Text>
          <Spacer mb={spc.s} /> */}
          {/* <Grid container spacing={4}>
            {policy?.controlBundleList.map((policy_) => (
              <Grid key={policy_._id} item xs={12}>
                <Spacer mb={spc.s} />
                <PolicyCard
                  className="modal-paper"
                  key={policy._id}
                  policy={policy_ as any}
                  avatar={<ControlBundleAvatar />}
                  noAction
                />
              </Grid>
            ))}
          </Grid> */}
        </div>
        <Spacer pb={spc.between_vertical_l} />
      </Arranger>
      <div className="modal-button">
        <Link href="/sign-up" rel="noopener">
          <Button color="info">Unlock The Full Experience</Button>
        </Link>
      </div>
    </Modal>
  );
};

const PublicPolicyModal = muiStyled(PublicPolicyModalImpl)(({ theme }) => {
  const isDarkMode = false;
  return css`
    .modal-paper {
      background: ${isDarkMode ? DesignToken.surface2 : DesignToken.surface1};
    }
    .modal-button {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
      @media (max-width: ${theme.breakpoints.values.md}px) {
        display: flex;
        justify-content: center;
        padding-top: 10px;
      }
    }

    .modal-width {
      padding: 20px 170px;
      @media (max-width: ${theme.breakpoints.values.sm}px) {
        padding: 20px 10px;
      }
      @media (max-width: ${theme.breakpoints.values.md}px) {
        padding: 20px 10px;
      }
    }
  `;
});
export default PublicPolicyModal;
